import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function getRandomUsername() {
  const usernames = [
    "networking_yahoo",
    "milflover1",
    "lukes_eyewalker",
    "ash_ketchup",
    "techtips420",
    "openclaw_QsG863bNL",
    "wei_ming_the_good",
    "kevin_the_evil",
    "ben-dover",
  ];
  return usernames[Math.floor(Math.random() * usernames.length)];
}

export function getRandomThirdPartyCount() {
  return Math.floor(Math.random() * 9699) + 300;
}